import symbolaccessSend from "bundle-text:./access-send.svg";
import symbolaccess from "bundle-text:./access.svg";
import symbolaccount from "bundle-text:./account.svg";
import symboladdRound from "bundle-text:./add--round.svg";
import symboladd from "bundle-text:./add.svg";
import symbolarrowBackWhite from "bundle-text:./arrow--back-white.svg";
import symbolarrowBack from "bundle-text:./arrow--back.svg";
import symbolarrowLeft from "bundle-text:./arrow--left.svg";
import symbolarrowRight from "bundle-text:./arrow--right.svg";
import symbolarrowUp from "bundle-text:./arrow--up.svg";
import symbolbackArrowSmall from "bundle-text:./back-arrow-small.svg";
import symbolbackArrow from "bundle-text:./back-arrow.svg";
import symbolbranding from "bundle-text:./branding.svg";
import symbolbrightness from "bundle-text:./brightness.svg";
import symbolcheckboxActive from "bundle-text:./checkbox--active.svg";
import symbolcheckbox from "bundle-text:./checkbox.svg";
import symbolcheckmarkRound from "bundle-text:./checkmark--round.svg";
import symbolcheckmarkRoundGrayDelete from "bundle-text:./checkmark-round-gray__DELETE.svg";
import symbolcheckMark from "bundle-text:./checkMark.svg";
import symbolcloseRound from "bundle-text:./close--round.svg";
import symbolclose from "bundle-text:./close.svg";
import symbolclosebtnGreyDelete from "bundle-text:./closebtn--grey__DELETE.svg";
import symbolclosebtnWhiteDelete from "bundle-text:./closebtn--white__DELETE.svg";
import symbolcloud from "bundle-text:./cloud.svg";
import symbolcollectDelete from "bundle-text:./collect__DELETE.svg";
import symbolcollectAdd from "bundle-text:./collect--add.svg";
import symbolcollect from "bundle-text:./collect.svg";
import symbolcollectionDelete from "bundle-text:./collection__DELETE.svg";
import symbolcollectionEmpty from "bundle-text:./collection--empty.svg";
import symbolcollection from "bundle-text:./collection.svg";
import symbolcontactHeader from "bundle-text:./contact-header.svg";
import symbolcopy from "bundle-text:./copy.svg";
import symbolcrop from "bundle-text:./crop.svg";
import symboldeleteAlt from "bundle-text:./delete--alt.svg";
import symboldeleteVisual from "bundle-text:./delete--visual.svg";
import symboldelete from "bundle-text:./delete.svg";
import symboldone from "bundle-text:./done.svg";
import symboldotsOutline from "bundle-text:./dots--outline.svg";
import symboldots from "bundle-text:./dots.svg";
import symboldownloadOutline from "bundle-text:./download--outline.svg";
import symboldownload from "bundle-text:./download.svg";
import symboledit from "bundle-text:./edit.svg";
import symbolemail from "bundle-text:./email.svg";
import symbolemptyCollectionDetail from "bundle-text:./empty-collection-detail.svg";
import symbolemptyCollections from "bundle-text:./empty-collections.svg";
import symbolemptyFiles from "bundle-text:./empty-files.svg";
import symbolemptyFolder from "bundle-text:./empty-folder.svg";
import symbolemptyNoPublicSpacesWhite from "bundle-text:./empty-no-public-spaces--white.svg";
import symbolemptyNoPublicSpaces from "bundle-text:./empty-no-public-spaces.svg";
import symbolemptySearch from "bundle-text:./empty-search.svg";
import symbolemptySpace from "bundle-text:./empty-space.svg";
import symbolemptySpaces from "bundle-text:./empty-spaces.svg";
import symbolerrorRound from "bundle-text:./error--round.svg";
import symbolerrorTriangle from "bundle-text:./error--triangle.svg";
import symboleuroBlack from "bundle-text:./euro--black.svg";
import symboleuro from "bundle-text:./euro.svg";
import symbolexternalLink from "bundle-text:./external-link.svg";
import symboleye from "bundle-text:./eye.svg";
import symboleyeglass from "bundle-text:./eyeglass.svg";
import symbolfacebook from "bundle-text:./facebook.svg";
import symbolfileComplex from "bundle-text:./file--complex.svg";
import symbolfileSimple from "bundle-text:./file--simple.svg";
import symbol3Dm from "bundle-text:./fileicons/3dm.svg";
import symbol3Ds from "bundle-text:./fileicons/3ds.svg";
import symbol7Z from "bundle-text:./fileicons/7z.svg";
import symbolai from "bundle-text:./fileicons/ai.svg";
import symbolaif from "bundle-text:./fileicons/aif.svg";
import symbolavi from "bundle-text:./fileicons/avi.svg";
import symbolblen from "bundle-text:./fileicons/blen.svg";
import symbolbmp from "bundle-text:./fileicons/bmp.svg";
import symbolcda from "bundle-text:./fileicons/cda.svg";
import symbolcss from "bundle-text:./fileicons/css.svg";
import symbolcsv from "bundle-text:./fileicons/csv.svg";
import symboldae from "bundle-text:./fileicons/dae.svg";
import symboldat from "bundle-text:./fileicons/dat.svg";
import symboldb from "bundle-text:./fileicons/db.svg";
import symboldoc from "bundle-text:./fileicons/doc.svg";
import symboldocx from "bundle-text:./fileicons/docx.svg";
import symboldwg from "bundle-text:./fileicons/dwg.svg";
import symboldxf from "bundle-text:./fileicons/dxf.svg";
import symboleps from "bundle-text:./fileicons/eps.svg";
import symbolfigma from "bundle-text:./fileicons/figma.svg";
import symbolflac from "bundle-text:./fileicons/flac.svg";
import symbolflv from "bundle-text:./fileicons/flv.svg";
import symbolgif from "bundle-text:./fileicons/gif.svg";
import symbolgz from "bundle-text:./fileicons/gz.svg";
import symbolheic from "bundle-text:./fileicons/heic.svg";
import symbolhtm from "bundle-text:./fileicons/htm.svg";
import symbolhtml from "bundle-text:./fileicons/html.svg";
import symbolico from "bundle-text:./fileicons/ico.svg";
import symbolidd from "bundle-text:./fileicons/idd.svg";
import symbolindd from "bundle-text:./fileicons/indd.svg";
import symboljpeg from "bundle-text:./fileicons/jpeg.svg";
import symboljpg from "bundle-text:./fileicons/jpg.svg";
import symboljs from "bundle-text:./fileicons/js.svg";
import symboljson from "bundle-text:./fileicons/json.svg";
import symbolkey from "bundle-text:./fileicons/key.svg";
import symbolmax from "bundle-text:./fileicons/max.svg";
import symbolmdb from "bundle-text:./fileicons/mdb.svg";
import symbolmidi from "bundle-text:./fileicons/midi.svg";
import symbolmodule from "bundle-text:./fileicons/module.svg";
import symbolmov from "bundle-text:./fileicons/mov.svg";
import symbolmp3 from "bundle-text:./fileicons/mp3.svg";
import symbolmp4 from "bundle-text:./fileicons/mp4.svg";
import symbolobj from "bundle-text:./fileicons/obj.svg";
import symbolodp from "bundle-text:./fileicons/odp.svg";
import symbolodt from "bundle-text:./fileicons/odt.svg";
import symbolotf from "bundle-text:./fileicons/otf.svg";
import symbolpdf from "bundle-text:./fileicons/pdf.svg";
import symbolphp from "bundle-text:./fileicons/php.svg";
import symbolpng from "bundle-text:./fileicons/png.svg";
import symbolppt from "bundle-text:./fileicons/ppt.svg";
import symbolppts from "bundle-text:./fileicons/ppts.svg";
import symbolpptx from "bundle-text:./fileicons/pptx.svg";
import symbolpsd from "bundle-text:./fileicons/psd.svg";
import symbolrar from "bundle-text:./fileicons/rar.svg";
import symbolrss from "bundle-text:./fileicons/rss.svg";
import symbolrtf from "bundle-text:./fileicons/rtf.svg";
import symbolsass from "bundle-text:./fileicons/sass.svg";
import symbolscss from "bundle-text:./fileicons/scss.svg";
import symbolsh from "bundle-text:./fileicons/sh.svg";
import symbolsitx from "bundle-text:./fileicons/sitx.svg";
import symbolskp from "bundle-text:./fileicons/skp.svg";
import symbol3Dm from "bundle-text:./fileicons/small/3dm.svg";
import symbol3Ds from "bundle-text:./fileicons/small/3ds.svg";
import symbol7Z from "bundle-text:./fileicons/small/7z.svg";
import symbolai from "bundle-text:./fileicons/small/ai.svg";
import symbolaif from "bundle-text:./fileicons/small/aif.svg";
import symbolavi from "bundle-text:./fileicons/small/avi.svg";
import symbolblen from "bundle-text:./fileicons/small/blen.svg";
import symbolbmp from "bundle-text:./fileicons/small/bmp.svg";
import symbolcda from "bundle-text:./fileicons/small/cda.svg";
import symbolcss from "bundle-text:./fileicons/small/css.svg";
import symbolcsv from "bundle-text:./fileicons/small/csv.svg";
import symboldae from "bundle-text:./fileicons/small/dae.svg";
import symboldat from "bundle-text:./fileicons/small/dat.svg";
import symboldb from "bundle-text:./fileicons/small/db.svg";
import symboldoc from "bundle-text:./fileicons/small/doc.svg";
import symboldocx from "bundle-text:./fileicons/small/docx.svg";
import symboldwg from "bundle-text:./fileicons/small/dwg.svg";
import symboldxf from "bundle-text:./fileicons/small/dxf.svg";
import symboleps from "bundle-text:./fileicons/small/eps.svg";
import symbolfigma from "bundle-text:./fileicons/small/figma.svg";
import symbolflac from "bundle-text:./fileicons/small/flac.svg";
import symbolflv from "bundle-text:./fileicons/small/flv.svg";
import symbolgif from "bundle-text:./fileicons/small/gif.svg";
import symbolgz from "bundle-text:./fileicons/small/gz.svg";
import symbolheic from "bundle-text:./fileicons/small/heic.svg";
import symbolhtm from "bundle-text:./fileicons/small/htm.svg";
import symbolhtml from "bundle-text:./fileicons/small/html.svg";
import symbolico from "bundle-text:./fileicons/small/ico.svg";
import symbolidd from "bundle-text:./fileicons/small/idd.svg";
import symbolindd from "bundle-text:./fileicons/small/indd.svg";
import symboljpeg from "bundle-text:./fileicons/small/jpeg.svg";
import symboljpg from "bundle-text:./fileicons/small/jpg.svg";
import symboljs from "bundle-text:./fileicons/small/js.svg";
import symboljson from "bundle-text:./fileicons/small/json.svg";
import symbolkey from "bundle-text:./fileicons/small/key.svg";
import symbolmax from "bundle-text:./fileicons/small/max.svg";
import symbolmdb from "bundle-text:./fileicons/small/mdb.svg";
import symbolmidi from "bundle-text:./fileicons/small/midi.svg";
import symbolmodule from "bundle-text:./fileicons/small/module.svg";
import symbolmov from "bundle-text:./fileicons/small/mov.svg";
import symbolmp3 from "bundle-text:./fileicons/small/mp3.svg";
import symbolmp4 from "bundle-text:./fileicons/small/mp4.svg";
import symbolobj from "bundle-text:./fileicons/small/obj.svg";
import symbolodp from "bundle-text:./fileicons/small/odp.svg";
import symbolodt from "bundle-text:./fileicons/small/odt.svg";
import symbolotf from "bundle-text:./fileicons/small/otf.svg";
import symbolpdf from "bundle-text:./fileicons/small/pdf.svg";
import symbolphp from "bundle-text:./fileicons/small/php.svg";
import symbolpng from "bundle-text:./fileicons/small/png.svg";
import symbolppt from "bundle-text:./fileicons/small/ppt.svg";
import symbolppts from "bundle-text:./fileicons/small/ppts.svg";
import symbolpptx from "bundle-text:./fileicons/small/pptx.svg";
import symbolpsd from "bundle-text:./fileicons/small/psd.svg";
import symbolrar from "bundle-text:./fileicons/small/rar.svg";
import symbolrss from "bundle-text:./fileicons/small/rss.svg";
import symbolrtf from "bundle-text:./fileicons/small/rtf.svg";
import symbolsass from "bundle-text:./fileicons/small/sass.svg";
import symbolscss from "bundle-text:./fileicons/small/scss.svg";
import symbolsh from "bundle-text:./fileicons/small/sh.svg";
import symbolsitx from "bundle-text:./fileicons/small/sitx.svg";
import symbolskp from "bundle-text:./fileicons/small/skp.svg";
import symbolsrt from "bundle-text:./fileicons/small/srt.svg";
import symbolsvg from "bundle-text:./fileicons/small/svg.svg";
import symboltar from "bundle-text:./fileicons/small/tar.svg";
import symboltga from "bundle-text:./fileicons/small/tga.svg";
import symboltif from "bundle-text:./fileicons/small/tif.svg";
import symboltiff from "bundle-text:./fileicons/small/tiff.svg";
import symbolttf from "bundle-text:./fileicons/small/ttf.svg";
import symboltwig from "bundle-text:./fileicons/small/twig.svg";
import symboltxt from "bundle-text:./fileicons/small/txt.svg";
import symbolurl from "bundle-text:./fileicons/small/url.svg";
import symbolvossebergen01 from "bundle-text:./fileicons/small/vossebergen-01.svg";
import symbolwav from "bundle-text:./fileicons/small/wav.svg";
import symbolwma from "bundle-text:./fileicons/small/wma.svg";
import symbolwmv from "bundle-text:./fileicons/small/wmv.svg";
import symbolwoff from "bundle-text:./fileicons/small/woff.svg";
import symbolwpl from "bundle-text:./fileicons/small/wpl.svg";
import symbolxlr from "bundle-text:./fileicons/small/xlr.svg";
import symbolxls from "bundle-text:./fileicons/small/xls.svg";
import symbolxlsx from "bundle-text:./fileicons/small/xlsx.svg";
import symbolxml from "bundle-text:./fileicons/small/xml.svg";
import symbolyml from "bundle-text:./fileicons/small/yml.svg";
import symbolzip from "bundle-text:./fileicons/small/zip.svg";
import symbolsrt from "bundle-text:./fileicons/srt.svg";
import symbolsvg from "bundle-text:./fileicons/svg.svg";
import symboltar from "bundle-text:./fileicons/tar.svg";
import symboltga from "bundle-text:./fileicons/tga.svg";
import symboltif from "bundle-text:./fileicons/tif.svg";
import symboltiff from "bundle-text:./fileicons/tiff.svg";
import symbolttf from "bundle-text:./fileicons/ttf.svg";
import symboltwig from "bundle-text:./fileicons/twig.svg";
import symboltxt from "bundle-text:./fileicons/txt.svg";
import symbolurl from "bundle-text:./fileicons/url.svg";
import symbolwav from "bundle-text:./fileicons/wav.svg";
import symbolwma from "bundle-text:./fileicons/wma.svg";
import symbolwmv from "bundle-text:./fileicons/wmv.svg";
import symbolwoff from "bundle-text:./fileicons/woff.svg";
import symbolwpl from "bundle-text:./fileicons/wpl.svg";
import symbolxlr from "bundle-text:./fileicons/xlr.svg";
import symbolxls from "bundle-text:./fileicons/xls.svg";
import symbolxlsx from "bundle-text:./fileicons/xlsx.svg";
import symbolxml from "bundle-text:./fileicons/xml.svg";
import symbolyml from "bundle-text:./fileicons/yml.svg";
import symbolzip from "bundle-text:./fileicons/zip.svg";
import symbolfilter from "bundle-text:./filter.svg";
import symbolflipHorizontal from "bundle-text:./flip-horizontal.svg";
import symbolflipVertical from "bundle-text:./flip-vertical.svg";
import symbolfolderAddOutline from "bundle-text:./folder--add-outline.svg";
import symbolfolderAdd from "bundle-text:./folder--add.svg";
import symbolfolderOpen from "bundle-text:./folder--open.svg";
import symbolfolderOutline from "bundle-text:./folder--outline.svg";
import symbolfolder from "bundle-text:./folder.svg";
import symbolfolderlock from "bundle-text:./folderlock.svg";
import symbolgear from "bundle-text:./gear.svg";
import symbolgift from "bundle-text:./gift.svg";
import symbolhelpHeader from "bundle-text:./help-header.svg";
import symbolherd from "bundle-text:./herd.svg";
import symbolhome from "bundle-text:./home.svg";
import symbolhue from "bundle-text:./hue.svg";
import symbolimageCrop from "bundle-text:./image-crop.svg";
import symbolimportant from "bundle-text:./important.svg";
import symbolinfoOutline from "bundle-text:./info--outline.svg";
import symbolinfo from "bundle-text:./info.svg";
import symbolinstagram from "bundle-text:./instagram.svg";
import symbollens from "bundle-text:./lens.svg";
import symbollink from "bundle-text:./link.svg";
import symbollinkedin from "bundle-text:./linkedin.svg";
import symbollistView from "bundle-text:./listView.svg";
import symbolloader from "bundle-text:./loader.svg";
import symbollockOpen from "bundle-text:./lock--open.svg";
import symbollockOutline from "bundle-text:./lock--outline.svg";
import symbollock from "bundle-text:./lock.svg";
import symbollogin from "bundle-text:./login.svg";
import symbollogoSmall from "bundle-text:./logo--small.svg";
import symbollogo from "bundle-text:./logo.svg";
import symbollogout from "bundle-text:./logout.svg";
import symbolmakeprivate from "bundle-text:./makeprivate.svg";
import symbolmanageHerdHeader from "bundle-text:./manage-herd-header.svg";
import symbolmasonry from "bundle-text:./masonry.svg";
import symbolmobiledevice from "bundle-text:./mobiledevice.svg";
import symbolmore from "bundle-text:./more.svg";
import symbolmove from "bundle-text:./move.svg";
import symbolmyspaceDelete from "bundle-text:./myspace__DELETE.svg";
import symbolmyspace from "bundle-text:./myspace.svg";
import symbolnew from "bundle-text:./new.svg";
import symbolnext from "bundle-text:./next.svg";
import symbolnotifyOutline from "bundle-text:./notify--outline.svg";
import symbolnotify from "bundle-text:./notify.svg";
import symbolpaste from "bundle-text:./paste.svg";
import symbolpause from "bundle-text:./pause.svg";
import symbolpinterest from "bundle-text:./pinterest.svg";
import symbolplanHeader from "bundle-text:./plan-header.svg";
import symbolplayBtn from "bundle-text:./play-btn.svg";
import symbolplay from "bundle-text:./play.svg";
import symbolprev from "bundle-text:./prev.svg";
import symbolprivacyLegal from "bundle-text:./privacy-legal.svg";
import symbolquickTransfer from "bundle-text:./quick-transfer.svg";
import symbolquicktransfer from "bundle-text:./quicktransfer.svg";
import symbolratio from "bundle-text:./ratio.svg";
import symbolrename from "bundle-text:./rename.svg";
import symbolreplaceVertical from "bundle-text:./replace--vertical.svg";
import symbolreplace from "bundle-text:./replace.svg";
import symbolresetEdit from "bundle-text:./reset-edit.svg";
import symbolreset from "bundle-text:./reset.svg";
import symbolroleAdd from "bundle-text:./role--add.svg";
import symbolrotateLeft from "bundle-text:./rotate-left.svg";
import symbolrotateRight from "bundle-text:./rotate-right.svg";
import symbolrotatedevice from "bundle-text:./rotatedevice.svg";
import symbolscreenSize from "bundle-text:./screenSize.svg";
import symbolselectArrow from "bundle-text:./select-arrow.svg";
import symbolselectSubject from "bundle-text:./select-subject.svg";
import symbolsend from "bundle-text:./send.svg";
import symbolshare from "bundle-text:./share.svg";
import symbolsheep from "bundle-text:./sheep.svg";
import symbolsort from "bundle-text:./sort.svg";
import symbolspaceAdd from "bundle-text:./space--add.svg";
import symbolspaceEdit from "bundle-text:./space--edit.svg";
import symbolspaceOne from "bundle-text:./space--one.svg";
import symbolspaceCreated from "bundle-text:./space-created.svg";
import symbolspace from "bundle-text:./space.svg";
import symbolstar from "bundle-text:./star.svg";
import symboltag from "bundle-text:./tag.svg";
import symboltemple from "bundle-text:./temple.svg";
import symbolterms from "bundle-text:./terms.svg";
import symboltiktok from "bundle-text:./tiktok.svg";
import symboltileView from "bundle-text:./tileView.svg";
import symboltransferBanner from "bundle-text:./transfer-banner.svg";
import symboltransferDownloadBanner from "bundle-text:./transfer-download-banner.svg";
import symboltransfer from "bundle-text:./transfer.svg";
import symboltwitter from "bundle-text:./twitter.svg";
import symboluploadFile from "bundle-text:./upload--file.svg";
import symboluploadIcon from "bundle-text:./upload--icon.svg";
import symboluploadBanner from "bundle-text:./upload-banner.svg";
import symboluploadField from "bundle-text:./upload-field.svg";
import symbolupload from "bundle-text:./upload.svg";
import symboluserAdd from "bundle-text:./user--add.svg";
import symboluserOutline from "bundle-text:./user--outline.svg";
import symboluser from "bundle-text:./user.svg";
import symbolusers from "bundle-text:./users.svg";
import symbolviewmore from "bundle-text:./viewmore.svg";
import symbolvimeo from "bundle-text:./vimeo.svg";
import symbolyoutube from "bundle-text:./youtube.svg";
import symbolzip from "bundle-text:./zip.svg";
;

export default {
  	"access-send": symbolaccessSend,
	"access": symbolaccess,
	"account": symbolaccount,
	"add--round": symboladdRound,
	"add": symboladd,
	"arrow--back-white": symbolarrowBackWhite,
	"arrow--back": symbolarrowBack,
	"arrow--left": symbolarrowLeft,
	"arrow--right": symbolarrowRight,
	"arrow--up": symbolarrowUp,
	"back-arrow-small": symbolbackArrowSmall,
	"back-arrow": symbolbackArrow,
	"branding": symbolbranding,
	"brightness": symbolbrightness,
	"checkbox--active": symbolcheckboxActive,
	"checkbox": symbolcheckbox,
	"checkmark--round": symbolcheckmarkRound,
	"checkmark-round-gray_DELETE": symbolcheckmarkRoundGrayDelete,
	"checkMark": symbolcheckMark,
	"close--round": symbolcloseRound,
	"close": symbolclose,
	"closebtn--grey_DELETE": symbolclosebtnGreyDelete,
	"closebtn--white_DELETE": symbolclosebtnWhiteDelete,
	"cloud": symbolcloud,
	"collect_DELETE": symbolcollectDelete,
	"collect--add": symbolcollectAdd,
	"collect": symbolcollect,
	"collection_DELETE": symbolcollectionDelete,
	"collection--empty": symbolcollectionEmpty,
	"collection": symbolcollection,
	"contact-header": symbolcontactHeader,
	"copy": symbolcopy,
	"crop": symbolcrop,
	"delete--alt": symboldeleteAlt,
	"delete--visual": symboldeleteVisual,
	"delete": symboldelete,
	"done": symboldone,
	"dots--outline": symboldotsOutline,
	"dots": symboldots,
	"download--outline": symboldownloadOutline,
	"download": symboldownload,
	"edit": symboledit,
	"email": symbolemail,
	"empty-collection-detail": symbolemptyCollectionDetail,
	"empty-collections": symbolemptyCollections,
	"empty-files": symbolemptyFiles,
	"empty-folder": symbolemptyFolder,
	"empty-no-public-spaces--white": symbolemptyNoPublicSpacesWhite,
	"empty-no-public-spaces": symbolemptyNoPublicSpaces,
	"empty-search": symbolemptySearch,
	"empty-space": symbolemptySpace,
	"empty-spaces": symbolemptySpaces,
	"error--round": symbolerrorRound,
	"error--triangle": symbolerrorTriangle,
	"euro--black": symboleuroBlack,
	"euro": symboleuro,
	"external-link": symbolexternalLink,
	"eye": symboleye,
	"eyeglass": symboleyeglass,
	"facebook": symbolfacebook,
	"file--complex": symbolfileComplex,
	"file--simple": symbolfileSimple,
	"3dm": symbol3Dm,
	"3ds": symbol3Ds,
	"7z": symbol7Z,
	"ai": symbolai,
	"aif": symbolaif,
	"avi": symbolavi,
	"blen": symbolblen,
	"bmp": symbolbmp,
	"cda": symbolcda,
	"css": symbolcss,
	"csv": symbolcsv,
	"dae": symboldae,
	"dat": symboldat,
	"db": symboldb,
	"doc": symboldoc,
	"docx": symboldocx,
	"dwg": symboldwg,
	"dxf": symboldxf,
	"eps": symboleps,
	"figma": symbolfigma,
	"flac": symbolflac,
	"flv": symbolflv,
	"gif": symbolgif,
	"gz": symbolgz,
	"heic": symbolheic,
	"htm": symbolhtm,
	"html": symbolhtml,
	"ico": symbolico,
	"idd": symbolidd,
	"indd": symbolindd,
	"jpeg": symboljpeg,
	"jpg": symboljpg,
	"js": symboljs,
	"json": symboljson,
	"key": symbolkey,
	"max": symbolmax,
	"mdb": symbolmdb,
	"midi": symbolmidi,
	"module": symbolmodule,
	"mov": symbolmov,
	"mp3": symbolmp3,
	"mp4": symbolmp4,
	"obj": symbolobj,
	"odp": symbolodp,
	"odt": symbolodt,
	"otf": symbolotf,
	"pdf": symbolpdf,
	"php": symbolphp,
	"png": symbolpng,
	"ppt": symbolppt,
	"ppts": symbolppts,
	"pptx": symbolpptx,
	"psd": symbolpsd,
	"rar": symbolrar,
	"rss": symbolrss,
	"rtf": symbolrtf,
	"sass": symbolsass,
	"scss": symbolscss,
	"sh": symbolsh,
	"sitx": symbolsitx,
	"skp": symbolskp,
	"3dm": symbol3Dm,
	"3ds": symbol3Ds,
	"7z": symbol7Z,
	"ai": symbolai,
	"aif": symbolaif,
	"avi": symbolavi,
	"blen": symbolblen,
	"bmp": symbolbmp,
	"cda": symbolcda,
	"css": symbolcss,
	"csv": symbolcsv,
	"dae": symboldae,
	"dat": symboldat,
	"db": symboldb,
	"doc": symboldoc,
	"docx": symboldocx,
	"dwg": symboldwg,
	"dxf": symboldxf,
	"eps": symboleps,
	"figma": symbolfigma,
	"flac": symbolflac,
	"flv": symbolflv,
	"gif": symbolgif,
	"gz": symbolgz,
	"heic": symbolheic,
	"htm": symbolhtm,
	"html": symbolhtml,
	"ico": symbolico,
	"idd": symbolidd,
	"indd": symbolindd,
	"jpeg": symboljpeg,
	"jpg": symboljpg,
	"js": symboljs,
	"json": symboljson,
	"key": symbolkey,
	"max": symbolmax,
	"mdb": symbolmdb,
	"midi": symbolmidi,
	"module": symbolmodule,
	"mov": symbolmov,
	"mp3": symbolmp3,
	"mp4": symbolmp4,
	"obj": symbolobj,
	"odp": symbolodp,
	"odt": symbolodt,
	"otf": symbolotf,
	"pdf": symbolpdf,
	"php": symbolphp,
	"png": symbolpng,
	"ppt": symbolppt,
	"ppts": symbolppts,
	"pptx": symbolpptx,
	"psd": symbolpsd,
	"rar": symbolrar,
	"rss": symbolrss,
	"rtf": symbolrtf,
	"sass": symbolsass,
	"scss": symbolscss,
	"sh": symbolsh,
	"sitx": symbolsitx,
	"skp": symbolskp,
	"srt": symbolsrt,
	"svg": symbolsvg,
	"tar": symboltar,
	"tga": symboltga,
	"tif": symboltif,
	"tiff": symboltiff,
	"ttf": symbolttf,
	"twig": symboltwig,
	"txt": symboltxt,
	"url": symbolurl,
	"vossebergen-01": symbolvossebergen01,
	"wav": symbolwav,
	"wma": symbolwma,
	"wmv": symbolwmv,
	"woff": symbolwoff,
	"wpl": symbolwpl,
	"xlr": symbolxlr,
	"xls": symbolxls,
	"xlsx": symbolxlsx,
	"xml": symbolxml,
	"yml": symbolyml,
	"zip": symbolzip,
	"srt": symbolsrt,
	"svg": symbolsvg,
	"tar": symboltar,
	"tga": symboltga,
	"tif": symboltif,
	"tiff": symboltiff,
	"ttf": symbolttf,
	"twig": symboltwig,
	"txt": symboltxt,
	"url": symbolurl,
	"wav": symbolwav,
	"wma": symbolwma,
	"wmv": symbolwmv,
	"woff": symbolwoff,
	"wpl": symbolwpl,
	"xlr": symbolxlr,
	"xls": symbolxls,
	"xlsx": symbolxlsx,
	"xml": symbolxml,
	"yml": symbolyml,
	"zip": symbolzip,
	"filter": symbolfilter,
	"flip-horizontal": symbolflipHorizontal,
	"flip-vertical": symbolflipVertical,
	"folder--add-outline": symbolfolderAddOutline,
	"folder--add": symbolfolderAdd,
	"folder--open": symbolfolderOpen,
	"folder--outline": symbolfolderOutline,
	"folder": symbolfolder,
	"folderlock": symbolfolderlock,
	"gear": symbolgear,
	"gift": symbolgift,
	"help-header": symbolhelpHeader,
	"herd": symbolherd,
	"home": symbolhome,
	"hue": symbolhue,
	"image-crop": symbolimageCrop,
	"important": symbolimportant,
	"info--outline": symbolinfoOutline,
	"info": symbolinfo,
	"instagram": symbolinstagram,
	"lens": symbollens,
	"link": symbollink,
	"linkedin": symbollinkedin,
	"listView": symbollistView,
	"loader": symbolloader,
	"lock--open": symbollockOpen,
	"lock--outline": symbollockOutline,
	"lock": symbollock,
	"login": symbollogin,
	"logo--small": symbollogoSmall,
	"logo": symbollogo,
	"logout": symbollogout,
	"makeprivate": symbolmakeprivate,
	"manage-herd-header": symbolmanageHerdHeader,
	"masonry": symbolmasonry,
	"mobiledevice": symbolmobiledevice,
	"more": symbolmore,
	"move": symbolmove,
	"myspace_DELETE": symbolmyspaceDelete,
	"myspace": symbolmyspace,
	"new": symbolnew,
	"next": symbolnext,
	"notify--outline": symbolnotifyOutline,
	"notify": symbolnotify,
	"paste": symbolpaste,
	"pause": symbolpause,
	"pinterest": symbolpinterest,
	"plan-header": symbolplanHeader,
	"play-btn": symbolplayBtn,
	"play": symbolplay,
	"prev": symbolprev,
	"privacy-legal": symbolprivacyLegal,
	"quick-transfer": symbolquickTransfer,
	"quicktransfer": symbolquicktransfer,
	"ratio": symbolratio,
	"rename": symbolrename,
	"replace--vertical": symbolreplaceVertical,
	"replace": symbolreplace,
	"reset-edit": symbolresetEdit,
	"reset": symbolreset,
	"role--add": symbolroleAdd,
	"rotate-left": symbolrotateLeft,
	"rotate-right": symbolrotateRight,
	"rotatedevice": symbolrotatedevice,
	"screenSize": symbolscreenSize,
	"select-arrow": symbolselectArrow,
	"select-subject": symbolselectSubject,
	"send": symbolsend,
	"share": symbolshare,
	"sheep": symbolsheep,
	"sort": symbolsort,
	"space--add": symbolspaceAdd,
	"space--edit": symbolspaceEdit,
	"space--one": symbolspaceOne,
	"space-created": symbolspaceCreated,
	"space": symbolspace,
	"star": symbolstar,
	"tag": symboltag,
	"temple": symboltemple,
	"terms": symbolterms,
	"tiktok": symboltiktok,
	"tileView": symboltileView,
	"transfer-banner": symboltransferBanner,
	"transfer-download-banner": symboltransferDownloadBanner,
	"transfer": symboltransfer,
	"twitter": symboltwitter,
	"upload--file": symboluploadFile,
	"upload--icon": symboluploadIcon,
	"upload-banner": symboluploadBanner,
	"upload-field": symboluploadField,
	"upload": symbolupload,
	"user--add": symboluserAdd,
	"user--outline": symboluserOutline,
	"user": symboluser,
	"users": symbolusers,
	"viewmore": symbolviewmore,
	"vimeo": symbolvimeo,
	"youtube": symbolyoutube,
	"zip": symbolzip,

};
